import React from 'react'

function Web({ selected = false }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="14" viewBox="0 0 24 14" style={{pointerEvents:"none"}}>
  <g dataname="Group 54643" transform="translate(-634 -13)">
    <g transform="translate(637 13)" fill="#fff" stroke="#000" strokeMiterlimit="10" strokeWidth="1">
      <rect width="18" height="12" rx="2" stroke={selected ? "#0072c6" : "#606060"}/>
      <rect x="0.5" y="0.5" width="17" height="11" rx="1.5" fill="none" stroke={selected ? "#0072c6" : "#606060"}/>
    </g>
    <g data-name="Rectangle Copy 64" transform="translate(634 24)" fill="#f4f4f4" stroke="#000" strokeMiterlimit="10" strokeWidth="1">
      <path d="M0,0H24a0,0,0,0,1,0,0V1a2,2,0,0,1-2,2H2A2,2,0,0,1,0,1V0A0,0,0,0,1,0,0Z" stroke={selected ? "#0072c6" : "#606060"}/>
      <path d="M1,.5H23a.5.5,0,0,1,.5.5V1A1.5,1.5,0,0,1,22,2.5H2A1.5,1.5,0,0,1,.5,1V1A.5.5,0,0,1,1,.5Z" fill="none" stroke={selected ? "#0072c6" : "#606060"}/>
    </g>
    <rect data-name="Rectangle" width="2" height="2" rx="1" transform="translate(645 24)" stroke={selected ? "#0072c6" : "#606060"} fill={selected ? "#0072c6" : "none"}/>
  </g>
</svg>

    )
}

export default Web
